import { BaseModel } from './base.model';
import { QuestionModel } from './question.model';

export class QuestionGroupModel extends BaseModel {

    name: string;
    weight: number;
    checklist_id: number;
    questions: QuestionModel[];
    item_order: number;
    previous_id?: number;
    origin_id?: number
    static validate(questionGroup: QuestionGroupModel): boolean {
        return !!(questionGroup.name);
    }

    constructor(questionGroup?: QuestionGroupModel) {
        super();
        this.name = questionGroup ? questionGroup.name || null : null;
        this.weight = questionGroup ? questionGroup.weight || null : null;
        this.checklist_id = questionGroup ? questionGroup.checklist_id || null : null;
        this.questions = questionGroup ? questionGroup.questions || [] : [];
    }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/model/question-group.model.ts